/* eslint angular/document-service: 0 */

module.exports = function(msi, dependencies = []) {
  angular.module(msi).run([
    '$state',
    'analytics',
    ($state, analytics) => {
      $state.go('root');

      analytics.init();
    }
  ]);

  angular.element(document).ready(() => {
    const msiElement = document.getElementById('og-msi');
    if (msiElement) {
      const node = document.createElement('ui-view');
      msiElement.appendChild(node);
    }
    if (msiElement) {
      angular.bootstrap(msiElement, dependencies.concat([msi]));
    }
  });
};
